import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { bootstrapSsoSession, getJwt } from "./lib/api";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

// PWA session bootstrap: installed iOS PWAs share same-origin cookies with
// Safari but NOT localStorage, so a freshly installed PWA boots with no
// stored JWT even though the user signed in via Safari. Before first render,
// try exchanging the HttpOnly SSO cookie for a fresh JWT so every
// getJwt()-gated page sees the session synchronously. Skipped entirely when
// a JWT is already stored; a 401 just means the user really is signed out.
async function boot() {
  if (!getJwt()) await bootstrapSsoSession();
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void boot();
